/**
 * InvestorPicker — searchable dropdown of investor users.
 * No API calls of its own; receives the list from the parent.
 */
import React, { useMemo, useState } from "react";

export default function InvestorPicker({ users = [], value, onChange }) {
  const [query, setQuery] = useState("");
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return users;
    return users.filter((u) =>
      (u.name || "").toLowerCase().includes(q) ||
      (u.email || "").toLowerCase().includes(q),
    );
  }, [users, query]);

  return (
    <div className="flex gap-2 flex-wrap" data-testid="operaciones-investor-picker">
      <input
        type="text"
        className="dv-input flex-1 min-w-[180px]"
        placeholder="Buscar por nombre o email…"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
      />
      <select
        className="dv-input flex-1 min-w-[200px]"
        value={value || ""}
        onChange={(e) => onChange(e.target.value || null)}
        data-testid="operaciones-investor-select"
      >
        <option value="">— Selecciona un inversor —</option>
        {filtered.map((u) => (
          <option key={u.user_id} value={u.user_id}>
            {u.name || "(sin nombre)"} — {u.email}
          </option>
        ))}
      </select>
    </div>
  );
}
